import { createActions } from "redux-actions";

// Define an enum for your action types
export enum ActionTypes {
  GET_INIT_DATA_VPO = "GET_INIT_DATA_VPO",
  GET_INIT_DATA_VPO_SUCCESS = "GET_INIT_DATA_VPO_SUCCESS",
  GET_INIT_DATA_VPO_FAILURE = "GET_INIT_DATA_VPO_FAILURE",
  GET_INIT_DATA_VPO_IDLE = "GET_INIT_DATA_VPO_IDLE",
  SET_FILTERS_DATE = "SET_FILTERS_DATE",
  SET_CONDITION = "SET_CONDITION",
  SET_CONDITION_SUCCESS = "SET_CONDITION_SUCCESS",
  SET_CONDITION_FAILURE = "SET_CONDITION_FAILURE",
  SET_CONDITION_IDLE = "SET_CONDITION_IDLE",
  GET_ACTION_DATA = "GET_ACTION_DATA",
  GET_ACTION_DATA_SUCCESS = "GET_ACTION_DATA_SUCCESS",
  GET_ACTION_DATA_FAILURE = "GET_ACTION_DATA_FAILURE",
  GET_ACTION_DATA_IDLE = "GET_ACTION_DATA_IDLE",
  GET_ACTIONS_DATA = "GET_ACTIONS_DATA",
  GET_ACTIONS_DATA_SUCCESS = "GET_ACTIONS_DATA_SUCCESS",
  GET_ACTIONS_DATA_FAILURE = "GET_ACTIONS_DATA_FAILURE",
  GET_ACTIONS_DATA_IDLE = "GET_ACTIONS_DATA_IDLE",

  SET_STATUS_QUESTIONARY = "SET_STATUS_QUESTIONARY",
  SET_STATUS_QUESTIONARY_SUCCESS = "SET_STATUS_QUESTIONARY_SUCCESS",
  SET_STATUS_QUESTIONARY_FAILURE = "SET_STATUS_QUESTIONARY_FAILURE",
  SET_STATUS_QUESTIONARY_IDLE = "SET_STATUS_QUESTIONARY_IDLE",

  SET_END_QUESTIONARY = "SET_END_QUESTIONARY",
  SET_END_QUESTIONARY_SUCCESS = "SET_END_QUESTIONARY_SUCCESS",
  SET_END_QUESTIONARY_FAILURE = "SET_END_QUESTIONARY_FAILURE",
  SET_END_QUESTIONARY_IDLE = "SET_END_QUESTIONARY_IDLE",

  COPY_PREV_MONTH = "COPY_PREV_MONTH",
  COPY_PREV_MONTH_SUCCESS = "COPY_PREV_MONTH_SUCCESS",
  COPY_PREV_MONTH_FAILURE = "COPY_PREV_MONTH_FAILURE",
  COPY_PREV_MONTH_IDLE = "COPY_PREV_MONTH_IDLE",

  GET_REPORT_FACTORY = "GET_REPORT_FACTORY",
  GET_REPORT_FACTORY_SUCCESS = "GET_REPORT_FACTORY_SUCCESS",
  GET_REPORT_FACTORY_FAILURE = "GET_REPORT_FACTORY_FAILURE",
  GET_REPORT_FACTORY_IDLE = "GET_REPORT_FACTORY_IDLE",

  GET_REPORT_COMPLETED_ACTIONS = "GET_REPORT_COMPLETED_ACTIONS",
  GET_REPORT_COMPLETED_ACTIONS_SUCCESS = "GET_REPORT_COMPLETED_ACTIONS_SUCCESS",
  GET_REPORT_COMPLETED_ACTIONS_FAILURE = "GET_REPORT_COMPLETED_ACTIONS_FAILURE",
  GET_REPORT_COMPLETED_ACTIONS_IDLE = "GET_REPORT_COMPLETED_ACTIONS_IDLE",

  GET_REPORT_SUMMARY = "GET_REPORT_SUMMARY",
  GET_REPORT_SUMMARY_SUCCESS = "GET_REPORT_SUMMARY_SUCCESS",
  GET_REPORT_SUMMARY_FAILURE = "GET_REPORT_SUMMARY_FAILURE",
  GET_REPORT_SUMMARY_IDLE = "GET_REPORT_SUMMARY_IDLE",

  SET_RETURN_QUESTIONARY = "SET_RETURN_QUESTIONARY",
  SET_RETURN_QUESTIONARY_SUCCESS = "SET_RETURN_QUESTIONARY_SUCCESS",
  SET_RETURN_QUESTIONARY_FAILURE = "SET_RETURN_QUESTIONARY_FAILURE",
  SET_RETURN_QUESTIONARY_IDLE = "SET_RETURN_QUESTIONARY_IDLE",

  GET_REPORT_ACTIONS = "GET_REPORT_ACTIONS",
  GET_REPORT_ACTIONS_SUCCESS = "GET_REPORT_ACTIONS_SUCCESS",
  GET_REPORT_ACTIONS_FAILURE = "GET_REPORT_ACTIONS_FAILURE",
  GET_REPORT_ACTIONS_IDLE = "GET_REPORT_ACTIONS_IDLE",
}

// Use the enum as a generic parameter in createActions function
const { 
  getInitDataVpo, 
  getInitDataVpoSuccess, 
  getInitDataVpoFailure, 
  getInitDataVpoIdle, 
  setCondition,
  setConditionSuccess,
  setConditionFailure,
  setConditionIdle, 
  getActionData,
  getActionDataSuccess,
  getActionDataFailure,
  getActionDataIdle, 
  getActionsData,
  getActionsDataSuccess,
  getActionsDataFailure,
  getActionsDataIdle,
  setStatusQuestionary,
  setStatusQuestionarySuccess,
  setStatusQuestionaryFailure,
  setStatusQuestionaryIdle,
  setEndQuestionary,
  setEndQuestionarySuccess,
  setEndQuestionaryFailure,
  setEndQuestionaryIdle,
  copyPrevMonth,
  copyPrevMonthSuccess,
  copyPrevMonthFailure,
  copyPrevMonthIdle,
  getReportFactory,
  getReportFactorySuccess,
  getReportFactoryFailure,
  getReportFactoryIdle,
  getReportCompletedActions,
  getReportCompletedActionsSuccess,
  getReportCompletedActionsFailure,
  getReportCompletedActionsIdle,
  getReportSummary,
  getReportSummarySuccess,
  getReportSummaryFailure,
  getReportSummaryIdle,
  setReturnQuestionary,
  setReturnQuestionarySuccess,
  setReturnQuestionaryFailure,
  setReturnQuestionaryIdle,
  getReportActions,
  getReportActionsSuccess,
  getReportActionsFailure,
  getReportActionsIdle,
} = createActions(
  ActionTypes.GET_INIT_DATA_VPO,
  ActionTypes.GET_INIT_DATA_VPO_SUCCESS,
  ActionTypes.GET_INIT_DATA_VPO_FAILURE,
  ActionTypes.GET_INIT_DATA_VPO_IDLE,
  ActionTypes.SET_CONDITION,
  ActionTypes.SET_CONDITION_SUCCESS,
  ActionTypes.SET_CONDITION_FAILURE,
  ActionTypes.SET_CONDITION_IDLE,
  ActionTypes.GET_ACTION_DATA,
  ActionTypes.GET_ACTION_DATA_SUCCESS,
  ActionTypes.GET_ACTION_DATA_FAILURE,
  ActionTypes.GET_ACTION_DATA_IDLE,
  ActionTypes.GET_ACTIONS_DATA,
  ActionTypes.GET_ACTIONS_DATA_SUCCESS,
  ActionTypes.GET_ACTIONS_DATA_FAILURE,
  ActionTypes.GET_ACTIONS_DATA_IDLE,
  ActionTypes.SET_STATUS_QUESTIONARY,
  ActionTypes.SET_STATUS_QUESTIONARY_SUCCESS,
  ActionTypes.SET_STATUS_QUESTIONARY_FAILURE,
  ActionTypes.SET_STATUS_QUESTIONARY_IDLE,
  ActionTypes.SET_END_QUESTIONARY,
  ActionTypes.SET_END_QUESTIONARY_SUCCESS,
  ActionTypes.SET_END_QUESTIONARY_FAILURE,
  ActionTypes.SET_END_QUESTIONARY_IDLE,
  ActionTypes.COPY_PREV_MONTH,
  ActionTypes.COPY_PREV_MONTH_SUCCESS,
  ActionTypes.COPY_PREV_MONTH_FAILURE,
  ActionTypes.COPY_PREV_MONTH_IDLE,
  ActionTypes.GET_REPORT_FACTORY,
  ActionTypes.GET_REPORT_FACTORY_SUCCESS,
  ActionTypes.GET_REPORT_FACTORY_FAILURE,
  ActionTypes.GET_REPORT_FACTORY_IDLE,
  ActionTypes.GET_REPORT_COMPLETED_ACTIONS,
  ActionTypes.GET_REPORT_COMPLETED_ACTIONS_SUCCESS,
  ActionTypes.GET_REPORT_COMPLETED_ACTIONS_FAILURE,
  ActionTypes.GET_REPORT_COMPLETED_ACTIONS_IDLE,
  ActionTypes.GET_REPORT_SUMMARY,
  ActionTypes.GET_REPORT_SUMMARY_SUCCESS,
  ActionTypes.GET_REPORT_SUMMARY_FAILURE,
  ActionTypes.GET_REPORT_SUMMARY_IDLE,
  ActionTypes.SET_RETURN_QUESTIONARY,
  ActionTypes.SET_RETURN_QUESTIONARY_SUCCESS,
  ActionTypes.SET_RETURN_QUESTIONARY_FAILURE,
  ActionTypes.SET_RETURN_QUESTIONARY_IDLE,
  ActionTypes.GET_REPORT_ACTIONS,
  ActionTypes.GET_REPORT_ACTIONS_SUCCESS,
  ActionTypes.GET_REPORT_ACTIONS_FAILURE,
  ActionTypes.GET_REPORT_ACTIONS_IDLE,
);

const { setFiltersDate } = createActions(
  ActionTypes.SET_FILTERS_DATE
)

export {
  getInitDataVpo, 
  getInitDataVpoSuccess, 
  getInitDataVpoFailure,
  getInitDataVpoIdle,
  setFiltersDate,
  setCondition,
  setConditionSuccess,
  setConditionFailure,
  setConditionIdle,
  getActionData,
  getActionDataSuccess,
  getActionDataFailure,
  getActionDataIdle,
  getActionsData,
  getActionsDataSuccess,
  getActionsDataFailure,
  getActionsDataIdle,
  setStatusQuestionary,
  setStatusQuestionarySuccess,
  setStatusQuestionaryFailure,
  setStatusQuestionaryIdle,
  setEndQuestionary,
  setEndQuestionarySuccess,
  setEndQuestionaryFailure,
  setEndQuestionaryIdle,
  copyPrevMonth,
  copyPrevMonthSuccess,
  copyPrevMonthFailure,
  copyPrevMonthIdle,
  getReportFactory,
  getReportFactorySuccess,
  getReportFactoryFailure,
  getReportFactoryIdle,
  getReportCompletedActions,
  getReportCompletedActionsSuccess,
  getReportCompletedActionsFailure,
  getReportCompletedActionsIdle,
  getReportSummary,
  getReportSummarySuccess,
  getReportSummaryFailure,
  getReportSummaryIdle,
  setReturnQuestionary,
  setReturnQuestionarySuccess,
  setReturnQuestionaryFailure,
  setReturnQuestionaryIdle,
  getReportActions,
  getReportActionsSuccess,
  getReportActionsFailure,
  getReportActionsIdle,
};
